// extracted by mini-css-extract-plugin
export default {"container":"talkToUs_container__BZbJg","TalkToUsBTn":"talkToUs_TalkToUsBTn__Lsbwo"};